// extracted by mini-css-extract-plugin
export default {"sliderBox":"uRXsZlPFDcUIVxJUHTvk"};